import { Injectable, OnDestroy } from '@angular/core'
import { Subject } from 'rxjs'
import FacebookEventsPlugin from './facebook-event.fixtures'

@Injectable({
  providedIn: 'root',
})
export class FacebookEventService implements OnDestroy {
  private _destroySubject$: Subject<void> = new Subject<void>()

  constructor() {}

  ngOnDestroy() {
    this._destroySubject$.next()
    this._destroySubject$.complete()
  }

  async logEvent(
    eventName: string,
    eventValues: { [key: string]: any } = undefined
  ) {
    FacebookEventsPlugin.logEvent({ eventName, parameters: eventValues })
  }
}
